import { createItemsData } from '../utils/request-utils'
import { Service } from './base-service'
import { HALApiService } from './hal-api.service'

export const postcodeService = new Service('/delivery-services/postcodes', HALApiService, createItemsData)
